import React from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import { Text } from '@atlaskit/primitives';

import { Option } from './types';

interface FastshiftTableFilterDropdownItemProps {
	option: Option;
	onClick: () => void;
	isSelected: boolean;
	customContent?: React.ReactNode;
}

export const FastshiftTableFilterDropdownItem: React.FC<FastshiftTableFilterDropdownItemProps> = ({
	option,
	onClick,
	isSelected,
	customContent,
}) => {
	return (
		<DropdownItem onClick={onClick} isSelected={isSelected}>
			{customContent ?? <Text>{option.label}</Text>}
		</DropdownItem>
	);
};
